import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LastPage from './LastPage';
import { PrimitiveLastPage } from './PrimitiveLastPage';
import NavBar, { View } from '../../components/NavBar';
import { withFetchPatient } from '../../components/hoc/withFetchPatient';
import { useDispatch, useSelector } from 'react-redux';
import * as store from '../../reducers/store';
import { setHeaderHidden } from '../../reducers/settings';

import styles from '../FormStart/index.module.css';
import {
  allCompleted,
  getLatestCompleted,
  getLastPageFormSet,
} from '../../utils/formSet';

export const FormEndComponent: React.FC = () => {
  const dispatch = useDispatch();
  const practicePreference = useSelector(
    (state: store.Loaded) => state.masterPracticePreference,
  );
  const isHeaderHidden = useSelector(
    (state: store.Loaded) => state.isHeaderHidden,
  );
  const formSets = useSelector((state: store.Loaded) => state.formSets);
  const completed = allCompleted(formSets);
  const hasLastPage = !!getLastPageFormSet(formSets);
  const [infoMessage, setInfoMessage] = useState<React.ReactNode | undefined>(
    undefined,
  );
  const { t } = useTranslation();

  useEffect(() => {
    const getFormattedDateTime = (completed: Date) => {
      const dayDiff = moment().diff(completed, 'days');
      const formattedTime = `${moment(completed).format('h:mm A')}`;
      if (dayDiff === 0) {
        return `${t('today at')} ${formattedTime}`;
      } else if (dayDiff === 1) {
        return `${t('yesterday at')} ${formattedTime}`;
      }
      return `${moment(completed).format('MMMM Do')} at ${formattedTime}`;
    };
    if (!isHeaderHidden) {
      dispatch(setHeaderHidden(true));
    }
    if (completed) {
      const latest = getLatestCompleted(formSets)!;
      setInfoMessage(
        <div className={styles.InfoMessage}>
          <strong>
            {t('You submitted this')}
            {` ${getFormattedDateTime(latest)}. `}
          </strong>
          {!practicePreference.enableOutreachIntakes &&
            t(
              'To make a change please let us know when you check in for your appointment.',
            )}
        </div>,
      );
    }
  }, [
    isHeaderHidden,
    completed,
    t,
    practicePreference.enableOutreachIntakes,
    dispatch,
    formSets,
  ]);
  return (
    <>
      <NavBar view={View.FormEnd} />
      <div className={styles.FormContainer}>
        <div className={styles.Form}>
          {hasLastPage ? (
            <PrimitiveLastPage
              formSets={formSets}
              practicePreference={practicePreference}
            />
          ) : (
            <LastPage
              infoMessage={infoMessage}
              practicePreference={practicePreference}
              label={practicePreference.lastLabel}
            />
          )}
        </div>
      </div>
    </>
  );
};

export const FormEnd = withFetchPatient(FormEndComponent);
export const FormEndMulti = withFetchPatient(FormEndComponent, { multi: true });
